module.exports = __webpack_public_path__ + "static/media/heckfire.3ebb01cc.jpeg";